import { ApplicationState, getV2State } from '../ApplicationState'
import { ActionIntegrationState } from './ActionIntegrations/ActionIntegrationState'
import { DailyReportState } from './DailyReport/DailyReportState'
import { EventState } from './Event/EventState'
import { FlashMessageState } from './FlashMessages/FlashMessageState'
import { ServerCapabilityState } from './ServerCapability/ServerCapabilityState'
import { TraceState } from './Trace/TraceState'
import { TracepointRuleState } from './TracepointRule/TracepointRuleState'
import { NavigationState } from './Navigation/NavigationState'
import { DynamicallyInstrumentedFunctionState } from './DynamicallyInstrumentedFunction/DynamicallyInstrumentedFunctionState'

export interface V2State {
    tracepointRules: TracepointRuleState
    integrations: ActionIntegrationState
    flashMessages: FlashMessageState
    dailyReports: DailyReportState
    events: EventState
    traces: TraceState
    serverCapabilities: ServerCapabilityState
    navigation: NavigationState
    dynamicallyInstrumentedFunctions: DynamicallyInstrumentedFunctionState
}

export const getEventState = (state: ApplicationState) => getV2State(state).events

export const getDailyReportState = (state: ApplicationState) => getV2State(state).dailyReports

export const getTracepointRuleState = (state: ApplicationState) => getV2State(state).tracepointRules

export const getActionIntegrationState = (state: ApplicationState) => getV2State(state).integrations

export const getDynamicallyInstrumentedFunctionState = (state: ApplicationState) => getV2State(state).dynamicallyInstrumentedFunctions

export const getFlashMessageState = (state: ApplicationState) => getV2State(state).flashMessages

export const getTraceState = (state: ApplicationState): TraceState => getV2State(state).traces

export const getServerCapabilityState = (state: ApplicationState): ServerCapabilityState => getV2State(state).serverCapabilities

export const getNavigationState = (state: ApplicationState): NavigationState => getV2State(state).navigation
